import * as types from "../types";

export const getFaqs = () => ({
  type: types.GET_FAQS,
  request: {
    url: "/faqs",
    method: "GET"
  }
});

export const getVideoFaqs = () => ({
  type: types.GET_VIDEO_FAQS,
  request: {
    url: "/video_faqs",
    method: "GET"
  }
});
export const getContactFaqs = () => ({
  type: types.GET_CONTACT_FAQS,
  request: {
    url: "/contact_faqs",
    method: "GET"
  }
});
